// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-view {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  padding-top: 80px; /* space for header */
  padding-bottom: 70px; /* space for footer */
  width: 100%;
  overflow: hidden;
}

.chat-header {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  padding: 10px;
  background-color: #323d4e;
  position: fixed;
  top: 72px;
  width: inherit;
  max-width: inherit;
  z-index: 1000;
}

.chat-header .profile-image .avatar {
  width: 40px;
  height: 40px;
  background-color: #364c63;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 15px;
  overflow: hidden;
}

.chat-header .profile-image .avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.chat-header .profile-image .avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.messages-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
}

/* .messages-container {
  /* max-height: 400px; Adjust as needed */
/* overflow-y: auto; */
/* scrollbar-width: none; For Firefox */
/* -ms-overflow-style: none; For Internet Explorer and Edge */
/* } */

/* For Chrome, Safari, and Edge */
.messages-container::-webkit-scrollbar {
  display: none;
}

.message {
  margin: 10px 0;
  max-width: 70%;
}

.message.me {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-content: flex-end;
  align-items: flex-end;
}

.message-content {
  padding: 10px 15px;
  border-radius: 15px;
  background-color: #007bff;
  color: white;
  display: inline-block;
}

.timestamp {
  text-align: center;
}

.message.them .message-content {
  background-color: #e9ecef;
  color: black;
}

.message-input {
  display: flex;
  padding: 15px;
  width: 81%;
  max-width: inherit;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #ddd;
  background-color: #1b2431;
  z-index: 1000;

}

.message-input input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 20px;
  margin-right: 10px;
}

.frmwdt {
  width: 100%;
  display: flex;
  align-items: baseline;
}

.message-input button {
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

.message-input button:hover {
  background-color: #0056b3;
}

.chat-header-content {
  display: flex;
  align-items: center;
}

.chat-info {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/components/ChatView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,iBAAiB,EAAE,qBAAqB;EACxC,oBAAoB,EAAE,qBAAqB;EAC3C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;0CAC0C;AAC1C,sBAAsB;AACtB,uCAAuC;AACvC,6DAA6D;AAC7D,MAAM;;AAEN,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;;AAEf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".chat-view {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  position: relative;\n  padding-top: 80px; /* space for header */\n  padding-bottom: 70px; /* space for footer */\n  width: 100%;\n  overflow: hidden;\n}\n\n.chat-header {\n  display: flex;\n  align-items: baseline;\n  flex-direction: column;\n  padding: 10px;\n  background-color: #323d4e;\n  position: fixed;\n  top: 72px;\n  width: inherit;\n  max-width: inherit;\n  z-index: 1000;\n}\n\n.chat-header .profile-image .avatar {\n  width: 40px;\n  height: 40px;\n  background-color: #364c63;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  margin-right: 15px;\n  overflow: hidden;\n}\n\n.chat-header .profile-image .avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.chat-header .profile-image .avatar .avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.messages-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n/* .messages-container {\n  /* max-height: 400px; Adjust as needed */\n/* overflow-y: auto; */\n/* scrollbar-width: none; For Firefox */\n/* -ms-overflow-style: none; For Internet Explorer and Edge */\n/* } */\n\n/* For Chrome, Safari, and Edge */\n.messages-container::-webkit-scrollbar {\n  display: none;\n}\n\n.message {\n  margin: 10px 0;\n  max-width: 70%;\n}\n\n.message.me {\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  align-content: flex-end;\n  align-items: flex-end;\n}\n\n.message-content {\n  padding: 10px 15px;\n  border-radius: 15px;\n  background-color: #007bff;\n  color: white;\n  display: inline-block;\n}\n\n.timestamp {\n  text-align: center;\n}\n\n.message.them .message-content {\n  background-color: #e9ecef;\n  color: black;\n}\n\n.message-input {\n  display: flex;\n  padding: 15px;\n  width: 81%;\n  max-width: inherit;\n  position: fixed;\n  bottom: 0;\n  border-top: 1px solid #ddd;\n  background-color: #1b2431;\n  z-index: 1000;\n\n}\n\n.message-input input {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  margin-right: 10px;\n}\n\n.frmwdt {\n  width: 100%;\n  display: flex;\n  align-items: baseline;\n}\n\n.message-input button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 20px;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n}\n\n.message-input button:hover {\n  background-color: #0056b3;\n}\n\n.chat-header-content {\n  display: flex;\n  align-items: center;\n}\n\n.chat-info {\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
